import { useI18n } from '../../../../i18n/i18n'
import './segments-strip.scss'

type Segment = { emoji: string; label: string }

export function SegmentsStrip() {
  const { t } = useI18n()
  const items = t('segments.items') as Segment[]
  return (
    <section className="segments-strip">
      <div className="segments-strip__head">
        <span className="eyebrow">{t('segments.eyebrow')}</span>
        <h2 className="section-heading">{t('segments.title')}</h2>
      </div>
      <div className="segments-strip__row">
        {items.map((s) => (
          <div className="segments-strip__item" key={s.label}>
            <span className="segments-strip__emoji" aria-hidden>{s.emoji}</span>
            <span className="segments-strip__label">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
